import { Image, Link, Text } from '@atoms/index';
import texts from '@components/ContactUs/en.json';
import { Fragment } from 'react';

const SocialMediaIcons = ({ socialMediaIcons }) => {
    const Icon = ({ icon }) => {
        return (
            <div className="w-6 h-medium:">
                <Link
                    key={icon.src}
                    href={icon.link}
                    children={<Image src={icon.src} alt={icon.alt} />}
                    target="_blank"
                />
            </div>
        );
    };
    return (
        <div className="px-4 py-3 lg:px-6 lg:py-4 shadow-custom-xs rounded-lg h-full">
            <div className="flex gap-2">
                <div className="flex justify-center items-center w-6 h-6">
                    <Image
                        src={`/images/contact-us/Send.svg`}
                        className="w-6 h-6"
                    />
                </div>
                <div className="flex flex-col gap-1 flex-1 -mt-0.5">
                    <Text
                        className="p4-regular text-gray-600"
                        content={texts?.ConnectWithUs}
                    />
                    <div className="flex gap-4 md:gap-2 xl:gap-4 items-end">
                        {socialMediaIcons.map((icon, index) => (
                            <Fragment key={index}>
                                <Icon icon={icon} />
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SocialMediaIcons;
